import { readingPlanConstants } from './constants/readingPlanConstants';

const readingPlanSave = (readingPlansInput: any) => {
	return {
		type: readingPlanConstants.ReadingPlanSaveRequest,
		input: readingPlansInput
	};
};


const readingPlanGetDetail = (readingPlansInput: any) => {
	return {
		type: readingPlanConstants.ReadingPlanDetailRequest,
		input: readingPlansInput
	};
};

const readingPlanGetByFilter = (filterInput: any) => {
	return {
		type: readingPlanConstants.ReadingPlanGetByFilterRequest,
		input: filterInput
	};
};

const readingPlanDelete = (id: any) => {
	return {
		type: readingPlanConstants.ReadingPlanDeleteRequest,
		input: id
	};
};

const readingPlanDaySave = (readingPlansInput: any) => {
	return {
		type: readingPlanConstants.ReadingPlanDaySaveRequest,
		input: readingPlansInput
	};
};

const readingPlanCopy = (Input: any) => {
	return {
		type: readingPlanConstants.ReadingPlanCopyRequest,
		input: Input
	};
};

const readingPlanDayDelete = (id: any) => {
	return {
		type: readingPlanConstants.ReadingPlanDayDeleteRequest,
		input: id
	};
};

export const readingPlanAction = {
	readingPlanSave,
	readingPlanGetDetail,
	readingPlanGetByFilter,
	readingPlanDelete,
	readingPlanDaySave,
	readingPlanCopy,
	readingPlanDayDelete
}